__turbopack_context__.v({
  "footerContainer": "Footer-module-scss-module__wcgw9G__footerContainer",
  "home": "Footer-module-scss-module__wcgw9G__home",
  "other": "Footer-module-scss-module__wcgw9G__other",
});
